const app_url = process.env.MIX_APP_URL;
const version = process.env.MIX_BE_VERSION;

function getUrlParams(params) {
    if (params) {
        for (let propName in params) {
            if (params.hasOwnProperty(propName)) {
                if (!params[propName]) {
                    delete params[propName];
                }
            }
        }

        return '?' + new URLSearchParams(params).toString();
    }

    return '';
}

export function doApi(language, params, ws_link) {
    return new Promise((resolve, reject) => {
        axios.post(app_url + "/" + language + "/webservice" + ws_link, Object.assign({}, {
            versione: version
        }, params)).then((response) => {
            if (response.data.success) {
                resolve(response.data.data);
            } else {
                reject({
                    messages: response.data.messages,
                    fromEndpoint: true,
                    data: response.data.data
                });
            }
        }).catch((error) => {
            reject({
                messages: ["Connection error"],
                fromEndpoint: false,
                data: null
            });
        });
    });
}

export function getApi(language, params, ws_link, apiKey = null) {
    const headers = {
        Accept: 'application/json',
        'X-Version': version,
    };
    if (apiKey) {
        headers['Authorization'] = 'Bearer ' + apiKey;
    }

    return new Promise(function (resolve, reject) {
        axios.get(
            app_url + '/' + language + '/webservice' + ws_link + getUrlParams(params),
            {
                headers,
            },
        )
            .then((response) => {
                if (response.data.success) {
                    resolve(response.data.data);
                } else {
                    reject({
                        messages: response.data.messages,
                        fromEndpoint: true,
                        data: response.data.data
                    });
                }
            })
            .catch((error) => {
                reject({
                    messages: ["Connection error"],
                    fromEndpoint: false,
                    data: null
                });
            });
    });
}

export function getImage(language, id_restaurant, code) {
    return app_url + "/" + language + "/webservice/restaurant/get_image/" + id_restaurant + "/" + code;
}

export function getCharacteristicIcon(language, name) {
    return app_url + "/" + language + "/webservice/restaurant/get_icon_caratteristica/" + name;
}

export function getFirebaseConfig(targa) {
    return new Promise((resolve, reject) => {
        axios.get("/assets/be/firebase/configs/" + targa + ".json").then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        });
    });
}
